import tw from 'twin.macro'

export const protoSelectRootCss = tw`relative min-w-0 flex-1`

export const protoSelectMenuCss = tw`absolute left-0 right-0 top-[calc(100%+4px)] z-[100] flex flex-col overflow-hidden rounded-[10px] border border-shades-200 bg-shades-0 shadow-[0_8px_24px_rgba(0,0,0,0.12)] border-solid`

export const protoSelectTriggerCss = (disabled: boolean, open: boolean, hasSelection: boolean) => [
  tw`flex h-[38px] w-full items-center justify-between gap-2 rounded-lg border border-solid px-3 text-sm outline-none transition-[border-color,box-shadow] duration-150`,
  disabled
    ? tw`cursor-not-allowed border-shades-200 bg-shades-50 opacity-[0.72] text-shades-500`
    : [
        tw`cursor-pointer bg-shades-0`,
        open
          ? tw`border-primary-400 shadow-[0_0_0_3px_var(--mui-primary-100)]`
          : tw`border-shades-200`,
        hasSelection ? tw`text-shades-900` : tw`text-shades-400`,
      ],
]

export const protoSelectChevronCss = (open: boolean) => [
  tw`flex-shrink-0 transition-transform duration-150`,
  open ? tw`rotate-180` : tw`rotate-0`,
]

export const protoSelectOptionCss = (isActive: boolean, isHighlighted = false) => [
  tw`flex cursor-pointer items-center justify-between px-3.5 py-2.5 text-sm transition-colors duration-100`,
  isActive
    ? tw`bg-primary-50 font-medium text-primary-700`
    : tw`bg-transparent font-normal text-shades-800 hover:bg-shades-50`,
  // Keyboard highlight has to read as distinct from both hover and the selected row —
  // focus sits in the search field, so this is the only cue for what Enter will pick.
  isHighlighted ? tw`bg-shades-100` : null,
]

export const protoSelectLabelCss = tw`overflow-hidden text-ellipsis whitespace-nowrap`

export const protoSelectSearchRowCss = tw`flex flex-shrink-0 items-center gap-2 border-0 border-b border-solid border-shades-200 px-3 py-2`

export const protoSelectSearchInputCss = tw`min-w-0 flex-1 border-0 bg-transparent p-0 text-sm text-shades-900 outline-none placeholder:text-shades-400`

export const protoSelectOptionListCss = tw`max-h-60 overflow-y-auto`

export const protoSelectEmptyCss = tw`px-3.5 py-2.5 text-sm text-shades-400`
